import {Button, Dropdown} from "antd";
import React from "react";
import {PageAction} from "./Page";
import ArrowDown from "../../assets/icons/ArrowDown";

export const PageButton = ({ action }: { action: PageAction}) => {
    const isDropdown = action.options?.items && action.options.items.length > 1;
    const button = <Button type="primary" disabled={action.isDisabled} className={`primary ${isDropdown ? 'dropdown' : ''}`} size="large" onClick={action.isDisabled || isDropdown ? () => null : action.action}>
        {action.label}
        {isDropdown ? <div className="dropdown-arrow"><ArrowDown width={18} height={18} color='#fff' /></div> : ''}
    </Button>;

    if(isDropdown) {
        return <Dropdown menu={action.options} placement="bottomRight" className="dropdown-container">
            {button}
        </Dropdown>;
    }

    return button;
}